import { IonButton, IonButtons, IonCard, IonCardHeader, IonCardTitle, IonContent, IonHeader, IonicSlides, IonImg, IonItem, IonLabel, IonList, IonListHeader, IonTitle,  IonToolbar } from '@ionic/react';
import React, {  useState } from 'react';
import { IonIcon } from '@ionic/react';
import { alarmSharp, linkSharp, medalSharp,} from 'ionicons/icons';
import { PMagicoProps } from '../interfaces';
import { Swiper, SwiperSlide } from 'swiper/react';

import { Autoplay, Keyboard, Pagination, Scrollbar, Zoom } from 'swiper';


// import required modules

import closePage from '../assets/close-circle.svg'
import location_white from '../assets/location-pin.svg'


//Estilos de cada carta
import './CardMuseo.css'


const PMagicoModal = ({
    marker,
    onDismiss,
  }: {
    marker : PMagicoProps;
    onDismiss: () => void;
  }) => {
    return (
        <>
           <IonHeader className='museo-ion-header'>
          <IonToolbar className='name-header-modal1 toolbar-modal-museo'>
              <IonButtons className='button-close'>
                <IonButton className='text-close-museo' onClick={() => onDismiss()}>
                  <img src={closePage} alt="imageClose" id='icon-close' />
                </IonButton>
              </IonButtons>
              <div className="image-potada">
                <img className='header-modal-img-museo'
                  src={(marker.urlImagen[0])}
                  alt={marker.nombre}
                />

              </div>
            <IonTitle>
            <div className="title">
                    <div className="localidad">
                        <div className="icon-loc">
                            <IonImg
                                src={location_white}            
                                alt="Location_white"
                            ></IonImg>
                        </div>
                        <div className="lugar">
                            {marker.municipio}
                        </div>
                    </div>
                </div>
            </IonTitle>
          </IonToolbar>
        </IonHeader>
        
        <IonContent fullscreen={true} className="ion-padding">
        
        <h3>{marker.nombre}</h3>
        <IonList>
            <IonItem>
            <p>
                {marker.descripcion}
            </p>
            </IonItem>
        </IonList>
              <Swiper
                // spaceBetween={5}
                modules={[Autoplay, Keyboard, Pagination, Scrollbar, Zoom, IonicSlides]}
                autoplay={true}
                keyboard={true}
                pagination={{
                  dynamicBullets: true,
                }}
                scrollbar={true}
                zoom={true}
                slidesPerView={1}
                onSlideChange={() => console.log('slide change')}
                onSwiper={(swiper) => console.log(swiper)}
              >
              {marker.urlImagen.map((element, index) => 
            <>
              <SwiperSlide>
                <IonCard id='swiper-ioncard'>
                <img className="img-swiper" alt='Hola' src={element} />
                  <IonCardHeader>
                    <IonCardTitle>{marker.nombre}</IonCardTitle>
                  </IonCardHeader>
                </IonCard>
              </SwiperSlide>
                </>
              )
              }
              </Swiper>

        <IonList className='Incluye padd-incluye'>
          <IonListHeader>
            <IonLabel className='title-incluye'>Atractivos</IonLabel>
          </IonListHeader>
          {
            marker.atractivos.map(element =>
              <>
                <IonItem className="terciary">
                  <h5>{element}</h5>
                </IonItem>
              </>  
            )
          }
          
        </IonList>

        <IonList className='Incluye padd-incluye'>
          <IonListHeader>
            <IonLabel className='title-incluye'>Festividades</IonLabel>
          </IonListHeader>
          {
            marker.festividades.map(element =>
              <>
                <IonItem>
                  <h5>{element}</h5>
                </IonItem>
              </>  
            )
          }
          
        </IonList>

        <IonList className='Incluye padd-incluye'>
          <IonListHeader>
            <IonLabel className='title-incluye'>Ubicación</IonLabel>
          </IonListHeader>
          <IonItem>
                  <h5>{marker.ubicacion}</h5>
            </IonItem>          
        </IonList>

        </IonContent>        </>
    );
};

export default PMagicoModal;